import { call, put } from "redux-saga/effects";
import uniqid from "uniqid";
import {
  saveCompanyAPI,
  downloadFile,
  uploadFile,
  getNewsByKey,
  getSpotByTypeKeyAPI,
  updataSpotAPI,
  getNews,
  saveCategoriesAPI,
  getCategoryByTypeField,
  savePremiumPlanAPI,
  getOnePremiumPLanByName,
} from "../services/api.js";
import {
  setIsLoading,
  updateSpotStor,
  setSpotToEdit,
  setNewsToEdit,
  setNews,
  setCategoryToEdit,
  getCategoryText,
  removeActiveType,
  setPremiumPlan,
  setBlogToEdit,
} from "../reduxSetup/action.js";

import { getTemplateByType } from "./../services/getSiteMap";

export function* saveCompany(data) {
  yield put(setIsLoading(true));
  const resp = yield call(saveCompanyAPI, data);
  if (resp.status === 200) {
    const company = data.company;
    company.status = "done";

    yield put(updateSpotStor(company, data.typeCompany));
  }
  yield put(setIsLoading(false));
}

export function* savePremiumPlan(data) {
  yield put(setIsLoading(true));
  const resp = yield call(savePremiumPlanAPI, data);
  if (resp.status === 200) {
  }
  yield put(setIsLoading(false));
}

export function* download(data) {
  const type = data.companyType;
  yield put(setIsLoading(true));
  const resp = yield call(downloadFile, { type: data.companyType });

  const fileValue = getTemplateByType(data.companyType, resp.data);
  const element = document.createElement("a");
  element.setAttribute(
    "href",
    "data::text/json;charset=utf-8," + [encodeURIComponent(fileValue)]
  );
  element.setAttribute("download", `sitemap${type}.xml`);

  document.body.appendChild(element);
  element.click();

  yield put(setIsLoading(false));
}

export function* upload(data) {
  yield put(setIsLoading(true));
  const resp = yield call(uploadFile, data);
  if (resp.status) {
    alert(`${resp.data} to ${data.country}`);
  }
  yield put(setIsLoading(false));
}

export function* getOneSpot({ data }) {
  yield put(setIsLoading(true));
  const resp = yield call(getSpotByTypeKeyAPI, data);
  if (resp.status === 200) {
    if (resp.data) {
      resp.data.type = data.type;
      yield put(setSpotToEdit(resp.data));
    } else {
      alert("Sorry we didn't find a spot with provided Key");
    }
  }
  yield put(setIsLoading(false));
}
export function* resetActiveType() {
  yield put(setIsLoading(true));
  yield call(removeActiveType());

  yield put(setIsLoading(false));
}
export function* getOneNewsByKey({ data }) {
  yield put(setIsLoading(true));
  const resp = yield call(getNewsByKey, data);
  if (resp.status === 200) {
    if (resp.data) {
      if (data.type === "blog") yield put(setBlogToEdit(resp.data));
      else yield put(setNewsToEdit(resp.data));
    } else {
      alert("Sorry we didn't find a news with provided Key");
    }
  }
  yield put(setIsLoading(false));
}

export function* getAllNews(data) {
  const resp = yield call(getNews, data);
  if (resp.status === 200) {
    yield put(setNews(resp.data));
    yield put(setIsLoading(false));
  }
}

export function* updateSpotDatabase({ spot, spotType }) {
  yield put(setIsLoading(true));
  const resp = yield call(updataSpotAPI, { spot, spotType });
  if (resp.status === 200) {
    if (resp.data) {
      yield put(updateSpotStor(spot, spotType));
    } else {
      alert("Sorry we didn't find a spot with provided Key");
    }
  }
  yield put(setIsLoading(false));
}

export function* saveCategories(data) {
  yield put(setIsLoading(true));
  yield call(saveCategoriesAPI, data);
  yield put(setIsLoading(false));
}

export function* getOneCategoryByTypeAndFields(data) {
  yield put(setIsLoading(true));
  const resp = yield call(getCategoryByTypeField, data);
  if (resp?.status === 200) {
    if (resp.data?.docs?.length) {
      yield put(setCategoryToEdit(resp.data.docs));
    } else {
      alert("Sorry we didn't find a category with provided Type and Fields");
    }
  }
  yield put(setIsLoading(false));
}
export function* getOnePremiumPLan(data) {
  yield put(setIsLoading(true));
  const resp = yield call(getOnePremiumPLanByName, data);
  if (resp?.status === 200) {
    if (resp.data?.length) {
      yield put(setPremiumPlan(resp.data));
    } else {
      alert("Sorry we didn't find a plan with provided by Name");
    }
  }
  yield put(setIsLoading(false));
}
